import {select, fork, take, put} from 'redux-saga/effects';
import fetchRequest from '../../application/sagas/fetchRequest';
import * as sarcActionTypes from '../sarcActionTypes';

/**
 * Search drop off location geolocation
 */
const searchSARCDropOffLocationGeolocation = function* searchSARCDropOffLocationGeolocation({payload}) {
    const {serviceManager} = yield select(state => state.application);
    const arcGISRESTService = serviceManager.loadService('arcGISRESTService');

    const {searchQueryString, serviceAssignmentId} = payload;
    yield fork(
        fetchRequest,
        sarcActionTypes.SEARCH_SARC_DROP_OFF_LOCATION_GEOLOCATION_REQUEST,
        arcGISRESTService.searchAddressSuggestions,
        {singleLine: searchQueryString, outFields: ['StAddr', 'Postal', 'City', 'Country', 'Region']},
    );

    const searchDamageLocationGeolocation = yield take([
        sarcActionTypes.SEARCH_SARC_DROP_OFF_LOCATION_GEOLOCATION_REQUEST_SUCCEEDED,
        sarcActionTypes.SEARCH_SARC_DROP_OFF_LOCATION_GEOLOCATION_REQUEST_FAILED,
    ]);

    if (!searchDamageLocationGeolocation.error) {
        const {response} = searchDamageLocationGeolocation.payload;
        const {arcGISLocationCandidateDTOs} = response;

        yield put({
            type: sarcActionTypes.SET_SARC_DROP_OFF_LOCATION_CANDIDATES,
            payload: {
                locationKey: 'dropOffLocation',
                arcGISLocationCandidateDTOs,
                serviceAssignmentId,
                searchQueryString,
            },
        });
    }
};

export default searchSARCDropOffLocationGeolocation;
